<template>
    <div v-if="post">
      <v-layout id="post">
            <v-flex xs12 sm6 offset-sm3>
              <v-card id="post-card">
                <h1 class="post-title">{{ post.title }}</h1>
                <p class="post-date">{{ post.date | formatDate }}</p>
                <p class="post-content"><pre>{{ post.content }}</pre></p>

                <v-card-actions>
                  <v-btn @click="deletePost" v-if="uid" flat color="red">Delete Post</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
      </v-layout>

    </div>
</template>

<script>
    import moment from 'moment';

    import { GET_POST_BY_PERMALINK, FETCH_POST, DELETE_POST, GET_USER } from '../store/types';

    export default {
        computed: {
            post() {
                return this.$store.getters[GET_POST_BY_PERMALINK]([this.$route.params.permalink]);
            },
            uid() {
                return this.$store.getters[GET_USER];
            }
        },
        filters: {
            formatDate(val) {
                return moment(val).format('DD-MM-YYYY [at] HH:mm');
            }
        },
        methods: {
            deletePost() {
                this.$store.dispatch(DELETE_POST, this.post._id);
                this.$router.push('/');
            }
        },
        created() {
            this.$store.dispatch(FETCH_POST, this.$route.params.permalink);
        }
    }
</script>

<style scoped>
    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
    }
    #post {
      margin-top: 50px;
    }
    #post-card {
      padding: 30px;
    }
    .post-title, .post-date, .post-content {
      text-align: left;
    }
</style>
